import { createRouter, createWebHistory } from 'vue-router'
import Home from './../components/HomeApp.vue'
import Products from './../components/products/ProductsApp.vue'
import Product from './../components/products/ProductDetail.vue'
import CrediCore from './../components/CrediCoreApp.vue'
import Cotizacion from './../components/CotizacionApp.vue'
import Security from '../components/security'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'AXUM S. de R.L. | Software, Odoo, CrediCore y transformación digital',
            description: 'AXUM S. de R.L. brinda desarrollo de software a la medida, implementación de Odoo, páginas web, hosting, soporte, capacitación y CrediCore para gestión de créditos y cobranza en empresas de distintos mercados.',
        },
    },
    {
        path: '/productos',
        name: 'Products',
        component: Products,
        meta: {
            title: 'Productos AXUM | Catálogo tecnológico',
            description: 'Explora el catálogo de productos tecnológicos disponibles de AXUM.',
        },
    },
    {
        path: '/producto/:id',
        name: 'Producto',
        component: Product,
        meta: {
            title: 'Detalle de producto | AXUM',
            description: 'Consulta los detalles, disponibilidad y precio de productos tecnológicos AXUM.',
        },
    },
    {
        path: '/credicore',
        name: 'CrediCore',
        component: CrediCore,
        meta: {
            title: 'CrediCore | Control de creditos, pagos y cobranza',
            description: 'CrediCore ayuda a administrar clientes, cuotas, mora, pagos, reportes e historial de cobranza desde un solo sistema.',
        },
    },
    {
        path: '/cotizacion/:productId?',
        name: 'Cotizacion',
        component: Cotizacion,
        meta: {
            title: 'Cotizacion | AXUM',
            description: 'Solicita una cotizacion de productos AXUM desde el formulario web.',
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to) {
        if (to.hash) {
            return {
                el: to.hash,
                top: 92,
                behavior: 'smooth',
            }
        }

        return { top: 0 }
    },
    routes
})

// this function will run every time a user navigates to any part of the site,
// and call checkToken(). If the user has a token in store.token, then we validate 
// that token.
router.beforeEach(() => {
    Security.checkToken();
})

router.afterEach((to) => {
    const defaultTitle = 'AXUM S. de R.L. | Soluciones tecnológicas para negocios'
    const defaultDescription = 'AXUM ofrece software a la medida, Odoo, CrediCore, páginas web, hosting, soporte tecnológico, capacitación y automatización para empresas de distintos mercados.'

    document.title = to.meta.title || defaultTitle

    const description = document.querySelector('meta[name="description"]')
    if (description) {
        description.setAttribute('content', to.meta.description || defaultDescription)
    }
})

export default router
